export default __webpack_public_path__ + "static/employee-wellbeing-banner-905d49b77defe2deff6cb1855f29e789.png";